import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FaCheckCircle, FaSnowflake } from 'react-icons/fa';

const DonorLeaderboard = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const donors = [
    { handle: "@tiger6z", amount: "$10,000", verified: true, url: "https://www.instagram.com/tiger6z?igsh=MTZ3enRxdTZmenNo" },
    { handle: "@chicobanes", amount: "$10,000", verified: true, url: "https://www.instagram.com/chicobanes?igsh=M24wcDh1Nm5nbzJ4" },
    { handle: "@landonsousaofficial", amount: "$10,000", verified: true, url: "https://www.instagram.com/landonsousaofficial?igsh=OHhnczVrY24wOXhn" },
    { handle: "@sosa10x", amount: "$10,000", verified: true, url: "https://www.tiktok.com/@sosa10x?_r=1&_t=ZT-91b0YA1JxE5" },
    { handle: "@properchaos", amount: "$10,000", verified: true, url: "https://www.instagram.com/properchaos?igsh=MWVrNzB4MnJ0eXo0aw==" },
    { handle: "@cryptodylnews", amount: "$10,000", verified: true, url: "https://www.instagram.com/cryptodylnews?igsh=d3dlbnN1Y3l6ZHNn" },
    { handle: "@crypto.kylo", amount: "$10,000", verified: true, url: "https://www.instagram.com/crypto.kylo?igsh=MWJ5dnQ4N2ZncHl6Ng==" },
    { handle: "@roccoscrypto", amount: "$10,000", verified: true, url: "https://www.instagram.com/roccoscrypto?igsh=aXByaTcxNnFjMG94" },
    { handle: "@itssbraz", amount: "$10,000", verified: true, url: "https://www.instagram.com/itssbraz?igsh=MW4xYmc4Y28zaXphYQ==" },
    { handle: "@shytheguy1", amount: "$10,000", verified: true, url: "https://www.instagram.com/shytheguy1?igsh=MnpxbnU1dm9iMjk0" },
    { handle: "@austinwhite.1", amount: "$10,000", verified: true, url: "https://www.instagram.com/austinwhite.1?igsh=OWN6M25vNGFidDNq" },
  ];

  return (
    <section ref={ref} className="relative py-32 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-5xl md:text-6xl font-black mb-6 text-center bg-gradient-to-r from-rizzmas-gold via-rizzmas-red to-rizzmas-green bg-clip-text text-transparent">
            OG Donors
          </h2>

          <motion.p
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl text-center text-rizzmas-cream/80 mb-12 max-w-3xl mx-auto"
          >
            The legends who put their money where their memes are
          </motion.p>

          {/* Desktop Table */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hidden md:block bg-rizzmas-dark/60 backdrop-blur-sm border border-rizzmas-gold/30 rounded-3xl overflow-hidden shadow-2xl shadow-rizzmas-gold/10"
          >
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-rizzmas-red/20 to-rizzmas-green/20 border-b border-rizzmas-gold/30">
                    <th className="px-8 py-6 text-left text-sm font-black text-rizzmas-gold uppercase tracking-wider">
                      Rank
                    </th>
                    <th className="px-8 py-6 text-left text-sm font-black text-rizzmas-gold uppercase tracking-wider">
                      Donor
                    </th>
                    <th className="px-8 py-6 text-left text-sm font-black text-rizzmas-gold uppercase tracking-wider">
                      Contribution
                    </th>
                    <th className="px-8 py-6 text-center text-sm font-black text-rizzmas-gold uppercase tracking-wider">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {donors.map((donor, index) => (
                    <motion.tr
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
                      transition={{ duration: 0.5, delay: 0.4 + index * 0.05 }}
                      whileHover={{ backgroundColor: "rgba(4, 120, 87, 0.1)", scale: 1.01 }}
                      className="border-b border-rizzmas-green/10 hover:border-rizzmas-green/30 transition-all duration-300"
                    >
                      <td className="px-8 py-6">
                        <div className="flex items-center">
                          <span className="text-2xl font-black text-rizzmas-gold">
                            #{index + 1}
                          </span>
                        </div>
                      </td>
                      <td className="px-8 py-6">
                        <a
                          href={donor.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xl font-bold text-rizzmas-cream hover:text-rizzmas-gold transition-colors"
                        >
                          {donor.handle}
                        </a>
                      </td>
                      <td className="px-8 py-6">
                        <span className="text-xl font-bold text-rizzmas-green">
                          {donor.amount}
                        </span>
                      </td>
                      <td className="px-8 py-6 text-center">
                        <div className="flex justify-center">
                          <FaCheckCircle className="text-3xl text-rizzmas-green" />
                        </div>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {donors.map((donor, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: 0.4 + index * 0.05 }}
                whileHover={{ scale: 1.02 }}
                className="bg-rizzmas-dark/60 backdrop-blur-sm border border-rizzmas-gold/30 rounded-2xl p-6 shadow-lg"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-2xl font-black text-rizzmas-gold">
                    #{index + 1}
                  </span>
                  <FaCheckCircle className="text-3xl text-rizzmas-green" />
                </div>
                <a
                  href={donor.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xl font-bold text-rizzmas-cream mb-2 block hover:text-rizzmas-gold transition-colors"
                >
                  {donor.handle}
                </a>
                <div className="text-xl font-bold text-rizzmas-green">
                  {donor.amount}
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="mt-16 bg-gradient-to-r from-rizzmas-green/20 via-rizzmas-dark to-rizzmas-red/20 border border-rizzmas-gold/40 rounded-2xl p-8 text-center"
          >
            <p className="text-2xl md:text-3xl text-rizzmas-cream font-bold mb-4">
              Large #RizzmasCTO social media marketing campaign
            </p>
            <p className="text-lg md:text-xl text-rizzmas-gold/90 flex items-center justify-center gap-2 flex-wrap">
              We will push multiple large marketing campaign through Instagram and Tiktok to spread awareness to the memecoin
              <FaSnowflake className="text-2xl text-rizzmas-cream inline-block" />
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default DonorLeaderboard;
